import axios, {AxiosResponse} from 'axios'
import {UserReportsQueryResponse} from './_models'
import {SearchReportsUsers} from '../../../../../_metronic/helpers'

const API_URL = process.env.REACT_APP_API_URL + '/api'
const REPORTS_URL = `${API_URL}/reports`

const getUserReports = (query: string): Promise<UserReportsQueryResponse> => {
  return axios
    .get(`${REPORTS_URL}/salesman?${query}`)
    .then((d: AxiosResponse<UserReportsQueryResponse>) => d.data)
}
const downloadServerFile = async (
  filter: string | undefined
): Promise<{message: string; id: number} | void> => {
  var filterAdjust = filter !== undefined ? `?${filter}` : ''
  const response = await axios({
    url: `${REPORTS_URL}/salesman/export${filterAdjust}`,
    method: 'GET',
    responseType: 'blob',
  })

  const contentType = response.headers['content-type'] ?? ''

  if (contentType.includes('application/json')) {
    const text = await (response.data as Blob).text()
    return JSON.parse(text) as {message: string; id: number}
  }

  const href = URL.createObjectURL(response.data)
  const link = document.createElement('a')
  link.href = href
  link.setAttribute('download', 'Relatorio_meta_de_venda.xlsx')
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(href)
}

export {getUserReports, downloadServerFile}
